import React, { useEffect } from 'react';
import { overlays } from '@ecosystem/newron-design-system';
import { EventElementCategory, EventElementType, ModalDsl, ModalName } from '../types';
import { Sections } from '../sections/sections';
import { trackPageElementClicked } from '../analytics/utils';
import { useAnalyticsContext } from '../analytics/analytics.provider';

const { Modal } = overlays;

type Props = {
  dsl: ModalDsl;
  onClose: () => void;
};
function CoreModal({ dsl, onClose }: Props) {
  useEffect(() => {
    return () => {
      // needed because design-system modal doesn't reset this prop leaving the whole page unscrollable!
      document.body.style.overflow = 'unset';
    };
  }, []);

  const { title, size, sections, name } = dsl;
  const { trackPageEvent } = useAnalyticsContext();

  const handleClose = () => {
    if (name === ModalName.KeyIndicators) {
      trackPageElementClicked(trackPageEvent, `Close ${name}`, {
        elementType: EventElementType.Card,
        elementCategory: EventElementCategory.CustomFilter,
      });
    }
    onClose();
  };

  return (
    <Modal isOpen size={size} onClose={handleClose}>
      <Modal.Header>{title}</Modal.Header>
      <Modal.Body>
        <Sections sections={sections} />
        <div id="menu-holder" className="fixed top-0 left-0 z-index-toast" />
      </Modal.Body>
    </Modal>
  );
}

export { CoreModal };
